import { checkMissingLocation } from '../../shared/helpers/location_Helper'

export function findPerson(personId, tree) {
  const pid = personId.replace('B_', '').replace('D_', '')
  return tree.find((element) => element.personId === pid)
}

export function updateWcfSelectedAncestor(personId, tree, which, dispatch) {
  const ancestor = findPerson(personId, tree)
  const birthPlace = checkMissingLocation(ancestor)

  if (birthPlace.place === '' && birthPlace.placeFull === '') {
    dispatch({
      type: 'SET_MISSING_LOCATION',
      data: { ancestor, isMissingLocationShowing: true, which },
    })
  } else {
    dispatch({
      type: 'SET_SELECTED_PERSON',
      data: { ancestor, isPersonViewerShowing: true, which },
    })
  }
}

export function clearPerson(which, dispatch) {
  dispatch({
    type: 'SET_SELECTED_PERSON',
    data: { selectedAncestor: null, isPersonViewerShowing: false, which },
  })
  dispatch({
    type: 'SET_MISSING_LOCATION',
    data: { selectedAncestor: null, isMissingLocationShowing: false, which },
  })
}

export function skipLocationModal(selectedAncestor, which, dispatch) {
  dispatch({
    type: 'SET_SELECTED_PERSON',
    data: { ancestor: selectedAncestor, isPersonViewerShowing: true, which },
  })
  dispatch({
    type: 'SET_MISSING_LOCATION',
    data: {
      ancestor: selectedAncestor,
      isMissingLocationShowing: false,
      which,
    },
  })
}
